import { FC } from 'react';
import { Card as _Card, CardHeader } from '@material-ui/core';
import styled from '@emotion/styled';

import { KaizenChartForHooks, Chart } from '@kaizenplatform/kaizen-chartjs';

import _ChartContainer from '../ChartBase/ChartContainer';
import PageTableChartDateSelector from './PageTableChartDateSelector';

type Props = {
  chart: Chart | null;
  loading: boolean;
  selectedDate: string;
  handleChangeDate: (event: any) => void;
};

const GoogleSearchConsolePageTableChart: FC<Props> = ({ chart, loading, selectedDate, handleChangeDate }) => {
  return (
    <Card>
      <CardHeader title="ページ別 検索データ" />
      <ChartWrapper>
        <ChartContainer>
          {chart ? (
            <PageTableChartDateSelector
              chartBreakdowns={chart.breakdowns}
              selectedDate={selectedDate}
              handleChangePageTableChartDate={handleChangeDate}
            />
          ) : null}
          <KaizenChartForHooks
            chartData={chart ? [chart] : null}
            identifier={{ id: chart ? chart.id : '' }}
            scope={{
              from: '',
              to: '',
            }}
            tableOptions={{
              pagination: true,
              sortOrder: {
                name: 'クリック数(前月)',
                direction: 'desc',
              },
            }}
            loading={loading}
          />
        </ChartContainer>
      </ChartWrapper>
    </Card>
  );
};

const Card = styled(_Card)(`
  .MuiCardHeader-root {
    padding: 24px;
  }
  .MuiCardHeader-title {
    color: #4C566C;
    font-weight: 700;
  }
`);

const ChartWrapper = styled('div')(`
  position: relative;
  padding: 0 24px 16px;
`);

const ChartContainer = styled(_ChartContainer)(`
  .MuiTableCell-root {
    font-size: 12px;
    max-width: 400px;
  }
  .MuiTableCell-head {
    font-weight: bold;
  }
  .MuiToolbar-root {
    min-height: 48px;
  }
  .MuiTableSortLabel-root {
    margin-top: 7px;
  }
`);

export default GoogleSearchConsolePageTableChart;
